export class TimeWarning {
    header: string;
    description: string;

    constructor(header: string, description: string) {
        this.header = header;
        this.description = description;
    }
}
